import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ColorScheme = 'grey' | 'orange'

export interface ColorSchemeColors {
  background: string
  backgroundHover: string
  textPrimary: string
  textSecondary: string
  accent: string
  alertBadge: string
}

export const colorSchemes: Record<ColorScheme, ColorSchemeColors> = {
  grey: {
    background: '#27343D',
    backgroundHover: '#FFFFFF1A',
    textPrimary: '#FFFFFF',
    textSecondary: '#FFFFFF80',
    accent: '#FFFFFF66',
    alertBadge: '#EF8B22',
  },
  orange: {
    background: '#EF8B22',
    backgroundHover: '#FFFFFF1A',
    textPrimary: '#FFFFFF',
    textSecondary: '#FFFFFF80',
    accent: '#FFFFFF66',
    alertBadge: '#00B7EA',
  },
}

interface ColorSchemeStore {
  colorScheme: ColorScheme
  setColorScheme: (scheme: ColorScheme) => void
  getColors: () => ColorSchemeColors
}

export const useColorSchemeStore = create<ColorSchemeStore>()(
  persist(
    (set, get) => ({
      colorScheme: 'grey',
      setColorScheme: (scheme) => set({ colorScheme: scheme }),
      getColors: () => colorSchemes[get().colorScheme],
    }),
    {
      name: 'color-scheme-storage',
    },
  ),
)
